import { webServiceUrl } from "../constants/api-end-pionts";

const connectWebSocket = (onMessageCallback: (data: string) => void) => {
    const token = localStorage.getItem("token");
  const socket = new WebSocket(`${webServiceUrl}${token}`);

  socket.onopen = () => {
    console.log("WebSocket connected");
    socket.send("Hello from client!");
  };

  socket.onmessage = (event) => {
    onMessageCallback(event.data);
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  socket.onclose = () => {
    console.log("WebSocket closed");
  };

  return socket; // return socket if you want to send data or close later
};

export default connectWebSocket;
